import React, { Component } from 'react';
import '../myutils';
import { connect } from 'react-redux';
import { translate} from 'react-admin';
import { push as pushAction } from 'react-router-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import IncomingCalls from './IncomingCalls';


const DurationField = ({ source, record = {} }) => <span>{moment.utc(record[source] * 1000).format('HH:mm:ss')}</span>;

DurationField.propTypes = {
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

class Softphone extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        return <IncomingCalls />
    }
}

Softphone.propTypes = {
    push: PropTypes.func,
    translate: PropTypes.func
}

export default connect(null, {
    push: pushAction,

})(translate(Softphone));